import { render, staticRenderFns } from "./chartBox2.vue?vue&type=template&id=556cd8c6&scoped=true"
import script from "./chartBox2.vue?vue&type=script&lang=js"
export * from "./chartBox2.vue?vue&type=script&lang=js"
import style0 from "./chartBox2.vue?vue&type=style&index=0&id=556cd8c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556cd8c6",
  null
  
)

export default component.exports